import React from 'react';
import { Box, Card, IconButton, Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { CheckCircleOutline } from '@mui/icons-material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { EventFeeBox } from './EventFeeBox';
import { EventList } from './EventList';
import { isEmpty } from '../../utils/lodash';

export interface IEventSuggestion {
    event: IEvent;
    disableSuggestion?: boolean;
    similarEvents?: IEvent[];
}

const EventRightBox: React.FC<IEventSuggestion> = ({ event, disableSuggestion, similarEvents }) => {
    const { themeStyle } = useThemeContext();

    return (
        <React.Fragment>
            <Stack direction="column">
                <Card
                    sx={{
                        width: '100%',
                        minWidth: '350px',
                        borderRadius: 2,
                        overflow: 'visible',
                        borderTop: `4px solid ${theme[themeStyle].highlight}`,
                        my: 2,
                        p: 2,
                        position: 'relative',
                        backgroundColor: theme[themeStyle].secondaryBg,
                    }}>
                    <IconButton
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 20,
                            borderRadius: 0,
                            borderBottomLeftRadius: '50%',
                            borderBottomRightRadius: '50%',
                            p: 0.5,
                            backgroundColor: theme[themeStyle].highlight,
                        }}>
                        <CheckCircleOutline sx={{ color: theme[themeStyle].true_white, fontSize: 24 }} />
                    </IconButton>
                    <EventFeeBox event={event} />
                </Card>
                {!disableSuggestion && (
                    <Card
                        sx={{
                            width: '100%',
                            borderRadius: 2,
                            overflow: 'visible',
                            p: 0,
                            minHeight: 'fit-content',
                            backgroundColor: theme[themeStyle].secondaryBg,
                        }}>
                        {similarEvents && !isEmpty(similarEvents) && (
                            <Box borderBottom={1}>
                                <Box px={2} py={1}>
                                    <Typography
                                        style={{
                                            fontFamily: FONT_ENUM.MAIN_BOLD,
                                            fontSize: 19,
                                            color: theme[themeStyle].tag_white,
                                        }}>
                                        Similar Events
                                    </Typography>
                                </Box>
                                <EventList events={similarEvents!} />
                            </Box>
                        )}
                    </Card>
                )}
            </Stack>
        </React.Fragment>
    );
};

export { EventRightBox };
